module.exports = __webpack_public_path__ + "img/puzzlingletters.baa3d790.png";